<nb-card>
	<nb-card-header class="history-collapsed-header">
		<span class="status-box {{offerHistoryStatus}}">{{ offerHistoryStatus.toUpperCase() }}</span>

		<a id="toggle-history-details" class="toggle-order-collapse" (click)="toggleCollapse()">
			{{ collapsed ? 'Show' : 'Hide' }}
			<nb-icon icon="{{collapsed ? 'arrow-ios-downward-outline' : 'arrow-ios-upward-outline'}}"></nb-icon>
		</a>
	</nb-card-header>
	<nb-card-body>
		@if (!isLead) {
			<h4>Estimate for {{ totalPrice() | price | async }} - {{ totalAuditTime() | number }} audit days</h4>
		}
		@if (isLead) {
			<h4>Estimate</h4>
		}
		<div class="order-number">Estimate number: {{ orderNumber() }}</div>

		<div>
			<div class="created-when">{{ changeSet.isInsert ? 'Estimate created' : 'Changes made' }} {{ changeSet.timestamp | dateAmountSince }}</div>
			<div class="timestamp">{{ changeSet.timestamp | localizedDate | async }}</div>
		</div>
	</nb-card-body>
</nb-card>

@if (!collapsed) {
	<div class="margin-bottom40">
		@if (!isLead) {
			<order-pricing [order]="changeSet.order" [orderUuid]="orderUuid()" [orderCorrelationId]="orderCorrelationId()" [products]="products()" [includeOffsiteDays]="includeOffsiteDays"
						   [allowPdfDownload]="false" [show3YearsTotalForClient]="true"
						   [showDownloadButtonText]="false" [changeSet]="changeSet" [showDailyRate]="showDailyRate"></order-pricing>
		}
		<historic-order-preview [changeSet]="changeSet" [isLead]="isLead" [billingInfoVisible]="billingInfoVisible" [latestOrderChanges]="latestOrderChanges"></historic-order-preview>
	</div>
}
